module.exports = __webpack_public_path__ + "img/twitter.e91dbc3e.svg";